import * as types from "../types/types";

const initialState = {
  isToggle: false,
};

const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TOGGLE_SIDEBAR:
      return {
        ...state,
        isToggle: action.payload,
      };
    default:
      return state;
  }
};

export default sidebarReducer;
